import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import { Sidebar } from 'primereact/sidebar';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { Button } from "@nextui-org/react";
import { motion, AnimatePresence, delay } from 'framer-motion'
import "./SideBarMobile.css"
import LogoutButton from '../Logout/LogoutButton';
import LogoutButtonMobile from '../Logout/LogoutButtonMobile';
export const SideBarMobile = ({ isSidebar, setSidebar, children, sideMenu, istabselected, SetTabselected, policyName,header,footer }) => {
  const navigate = useNavigate();
  return (
    <Sidebar
      visible={isSidebar}
      onHide={() => setSidebar(false)}


    >
    <div className='d-flex align-items-stretch justify-content-evenly flex-column' style={{height:"100%"}}>
    <div className='d-flex justify-content-center align-items-center '>
        {header}

      </div>
      <div className='pt-3'>
        {sideMenu.map((value, index) => {

          return (

            <motion.div
              initial={{
                x: "-100%",
                opacity: 0

              }}
              animate={{
                transition: {
                  delay: 0.1 * index,
                  duration: 0.5,
                }
                ,
                x: "0%"
                ,
                opacity: 1
              }}
            >
              <Row className='d-flex justify-content-center align-items center side-menu-items side-menu-btn-mobile ' style={{ width: "100%" }}>
                <Button disableRipple isDisabled={value.isDisabled} variant="ghost" className={`side-menu-items-btn  ${istabselected !== value.url ? 'me-4' : ''}`} onClick={() => { SetTabselected(value.url); navigate("/customer-portal/" + value.url + "?policy-id=" + policyName) ;setSidebar(false)}} style={istabselected === value.url ? { color: "white" } : {}}>
                  <Col xs={2} >{value.icon} </Col>
                  <Col xs={8} >{value.label}</Col>

                </Button>
                <AnimatePresence>
                  {istabselected == value.url && (
                    <motion.span
                      className="ab-btn"
                      initial={{ scale: 0 }}
                      animate={{ scale: 1, transition: { ease: "easeInOut" } }}
                      exit={{ scale: 0 }}

                    ></motion.span>
                  )}
                </AnimatePresence>

              </Row>
            </motion.div>
          )




        })}
      </div>
      <div className='d-flex justify-content-between align-items-center mx-2'>
        {footer}
        
        <LogoutButtonMobile/>
      </div>
    </div>
    </Sidebar>
  )
}
